import * as React from 'react';

export enum ContentSpecType {
  Point = 1, // 点
  BlankSpace = 2, // 空格
  Line = 3 // 空格
}
export interface ContentSpecStyle {
  specType?: ContentSpecType; // 默认 点分隔符
  spec?: number; //  spec 间距 默认 3
}
export interface ItemStyle {
  customProperty?: any; // custom property 单个item的特殊处理或传参
  maxLines?: number; //  rich-text max line
  justifyContent?: string; //  DynamicTagGroup 居中
  flexShrink?: number;
  flexGrow?: number;
  dynamicTagIsZeroMargin?: boolean; // 动态标签右边距为0 解决item margin right带来的边距问题(例如单行最后一个item用户看到边距)
}
export interface HeaderItemProps {
  itemKey: string; // key
  data: any; // data
  hasLastItem: boolean; // 是否有下一个可渲染item, 追加分隔符，分隔符在当前item后拼接
  style?: ItemStyle; //特殊处理属性在customStyles中赋值处理
  specStyle?: ContentSpecStyle; // 默认 点分隔符 间距3
}

export interface ContentItemState {
}

export default class ContentSuperItem<P extends HeaderItemProps = HeaderItemProps, S extends ContentItemState = ContentItemState> extends React.PureComponent<P, S> {

}
